/* globals gtag */
import React, { useEffect, useState, useCallback, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  SetSearchWord,
  SetUrlPrefix,
  SetImgPrefix,
  SetActiveFilters,
  SetMasterCategories,
  SetProducts,
  SetSuggestedWords,
  SetSliderValueMinMax,
  SetFilters,
  SetPrevProducts,
  SetAsyncData,
  SetListingBanner,
  SetResultsCount,
  SetPages,
  SetPage,
  SetSliderValue,
  SetIsSearching,
  SetIsExpanded,
} from "../../state/actions/index"
import "./VoiceRecognition.css"
import Utils from "../../utils/Utils"
import axios from "axios"

const VoiceRecognition = () => {
  const [isVoiceRecognitionSupported, setIsVoiceRecognitionSupported] =
    useState(false)
  const [isRecording, setIsRecording] = useState(false)
  const [recognition, setRecognition] = useState(false)
  const sort = useSelector((state) => state.sort)
  const shopId = useSelector((state) => state.config.shopId)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const card = useSelector((state) => state.config.card)
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const config = useSelector((state) => state.config)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const activeFilters = useSelector((state) => state.activeFilters)
  const language = useSelector((state) => state.config.voiceSearch.language)
  const filters = useSelector((state) => state.config.filters)
  const accentColor = useSelector((state) => state.config.accentColor)
  const ga4 = useSelector((state) => state.config.ga4)
  const dispatch = useDispatch()

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(filters).forEach((filter) => {
      if (filters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [filters])

  const toggleRecording = useCallback(() => {
    Utils.sendAnalyticsObject(
      baseUrl,
      shopId,
      isRecording ? "as_close_voice" : "as_open_voice"
    )
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: isRecording ? "as_close_voice" : "as_open_voice",
          data: {},
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", isRecording ? "as_close_voice" : "as_open_voice", {})
      }
    }
    setIsRecording(!isRecording)
    if (isRecording) recognition.stop()
    else recognition.start()
  }, [setIsRecording, isRecording, recognition, shopId, baseUrl])

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition ||
      window.webkitSpeechRecognition ||
      window.mozSpeechRecognition ||
      window.msSpeechRecognition ||
      window.oSpeechRecognition
    setIsVoiceRecognitionSupported(SpeechRecognition !== undefined)
    if (SpeechRecognition !== undefined) {
      const recognition = new SpeechRecognition()
      setRecognition(recognition)
      /*  en-US, en-GB, es-ES, fr-FR, it-IT, de-DE, ja-JP, pt-BR, zh-CN */
      recognition.lang = language
      recognition.addEventListener("end", () => {
        Utils.sendAnalyticsObject(baseUrl, shopId, "as_close_voice")
        if (!!ga4?.isActive) {
          if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
            window.dataLayer.push({
              event: "as_close_voice",
              data: {},
            })
          } else if (typeof gtag !== "undefined") {
            gtag("event", "as_close_voice", {})
          }
        }
        setIsRecording(false)
      })
      recognition.addEventListener("result", (value) => {
        Utils.sendAnalyticsObject(baseUrl, shopId, "as_success_voice")
        if (!!ga4?.isActive) {
          if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
            window.dataLayer.push({
              event: "as_success_voice",
              data: {},
            })
          } else if (typeof gtag !== "undefined") {
            gtag("event", "as_success_voice", {})
          }
        }
        var searchWord = value.results[0][0].transcript
        dispatch(SetSearchWord(searchWord))
        dispatch(SetActiveFilters([]))
        dispatch(SetIsSearching(true))
        dispatch(SetAsyncData([]))
        var priceGroup = {}
        priceGroup.id =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
            ? window.AS_ADVANCED_CONFIG.visitorType
            : config.priceGroup.id
        priceGroup.currency =
          window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
            ? window.AS_ADVANCED_CONFIG.currencyCode
            : config.priceGroup.currency
        var localSearchUrl = Utils.getSearchUrl(
          config.baseUrl,
          config.queryOptions,
          priceGroup,
          config.shopId,
          config.jsonFast
        )
        axios
          .get(
            Utils.insertWordInSearchUrl(
              localSearchUrl,
              searchWord,
              activeFilters,
              sort,
              1,
              filters,
              rows
            )
          )
          .then((res) => {
            var response = res.data
            dispatch(SetIsExpanded({}))
            dispatch(
              SetMasterCategories(
                response.stats[categoryKey]
                  ? Utils.refactorMasterCategories(
                      Object.keys(response.stats[categoryKey])
                    )
                  : defaultMasterCategories
              )
            )
            dispatch(SetPrevProducts(products))
            dispatch(
              SetProducts(
                Utils.refactorUrl(
                  response.data,
                  response.header.imagePrefix,
                  response.header.urlPrefix,
                  card.img,
                  card.url
                )
              )
            )
            dispatch(SetSuggestedWords(response.suggestions))
            dispatch(SetResultsCount(response.header.results_count))
            dispatch(
              SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
            )
            dispatch(SetPage(1))
            dispatch(SetListingBanner(response.banners[0]))
            dispatch(
              SetSliderValue(Utils.addSliderValue(response, sliderValue))
            )
            dispatch(
              SetSliderValueMinMax(
                Utils.addSliderValue(response, sliderValueMinMax)
              )
            )
            dispatch(SetFilters(response))
            dispatch(SetUrlPrefix(response.header.urlPrefix))
            dispatch(SetImgPrefix(response.header.imagePrefix))
            if (config.webhook.key !== "")
              Utils.getAsyncData(
                config.webhook,
                response.data,
                priceGroup
              ).then((value) => dispatch(SetAsyncData(value.asyncData)))
          })
          .finally(() => dispatch(SetIsSearching(false)))
      })
    }
  }, [
    setIsVoiceRecognitionSupported,
    setRecognition,
    language,
    dispatch,
    config,
    activeFilters,
    sort,
    filters,
    products,
    rows,
    categoryKey,
    card,
    sliderValue,
    sliderValueMinMax,
    defaultMasterCategories,
    shopId,
    baseUrl,
  ])

  return isVoiceRecognitionSupported ? (
    <button
      className={"mic " + (isRecording ? "isRecording" : "")}
      onClick={toggleRecording}
    >
      {!isRecording ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
            style={{ fill: accentColor }}
          />
        </svg>
      ) : null}
    </button>
  ) : null
}

export default VoiceRecognition
